import { getById } from 'apis/organizations.api';

const { useMemo } = require('react');
const { useQuery } = require('react-query');

const useGetOrganizationById = (id, conds = {}) => {
  const { data: organizationData, ...rest } = useQuery(['organizations', id], () => getById(id), {
    ...conds,
  });

  const organization = useMemo(() => organizationData?.data ?? {}, [organizationData]);

  return { data: organization, ...rest };
};

export default useGetOrganizationById;
